import axios from 'axios'
import { addToCart } from '~/js/helpers/addToCart'
import { pushCartAddedEvent } from '~/js/gtm'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'
import './review.js'

const CLASS_NAME_RECEIPT_ISSUE_TRIGGER = 'js-receipt-issue-trigger'
const TEXT_RECEIPT_ISSUED = '既に領収書を発行済みです'
const QUERY_REORDER = '.product__cart[action="/cart/add"]'

document.addEventListener('DOMContentLoaded', () => {
  const elementsButtonClose = document.querySelectorAll(
    '#receipt-popup .btn-close'
  )
  Array.from(elementsButtonClose).forEach((element) => {
    element.addEventListener('click', ($event) => {
      $event.preventDefault()
      $.magnificPopup.close()
    })
  })

  const elementsButtonReorder = document.querySelectorAll(QUERY_REORDER)
  if (elementsButtonReorder.length) {
    elementsButtonReorder.forEach((element) => {
      element.addEventListener('submit', async (event) => {
        event.preventDefault()
        const form = event.target
        const item = {
          handle: form.dataset.handle,
          id: form.dataset.variantId,
          image: form.dataset.productImage || '',
          productTitle: form.dataset.productTitle || '',
          productTitlePrefix: form.dataset.productTitlePrefix || '',
          quantity: 1,
        }
        const { itemsAdded, itemsAddFailed } = await addToCart([item])
        window.dispatchEvent(
          new CustomEvent('cart-added', {
            detail: { items: itemsAdded, itemsAddFailed },
          })
        )
        pushCartAddedEvent({ items: itemsAdded })
      })
    })
  }

  const elementsReceiptIssueTrigger = document.getElementsByClassName(
    CLASS_NAME_RECEIPT_ISSUE_TRIGGER
  )
  if (!elementsReceiptIssueTrigger.length) return

  const elementsButtonOpenReceiptPopup = document.getElementsByClassName(
    'js-buttonOpenReceiptPopup'
  )

  Array.from(elementsReceiptIssueTrigger).forEach((element) => {
    element.addEventListener('click', ($event) => {
      if (element.hasAttribute('disabled')) {
        $event.preventDefault()
        return
      }

      Array.from(elementsButtonOpenReceiptPopup).forEach((el) => {
        const textNode = document.createTextNode(TEXT_RECEIPT_ISSUED)
        el.parentNode.replaceChild(textNode, el)
      })

      element.innerText = TEXT_RECEIPT_ISSUED
      element.setAttribute('disabled', true)

      const o = element.dataset.orderId
      const h = element.dataset.hash

      axios.post(`${baseUrlFrontApi}/receiptissued`, { o, h }).catch((e) => {
        console.error(e)
      })
    })
  })
})
